import { faWarning } from "@fortawesome/pro-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { type PropsWithChildren } from "react";

import { T } from "@repo/transifex";
import { Button, DialogError } from "~/components";
import { useModal } from "~/components/hooks/use-modal";

type PaymentButtonCardProps = {
  isTerminalConnected: boolean;
  hidden: boolean;
};

export const PaymentTerminalButton = ({
  isTerminalConnected,
  hidden,
  children
}: PropsWithChildren<PaymentButtonCardProps>) => {
  const { showModal, hideModal } = useModal();

  if (hidden) return null;

  if (!isTerminalConnected) {
    return (
      <Button
        textClassName="whitespace-normal break-words text-xs xl:text-sm"
        className="min-w-0 flex-1 rounded-none"
        icon={faWarning}
        onClick={() => {
          showModal({
            component: <DialogTerminalNotConnected onClose={hideModal} />
          });
        }}
        size="large"
        variant="danger-light"
      >
        <T _str="Terminal disconnected" />
      </Button>
    );
  }

  return children;
};

type DialogTerminalNotConnectedProps = {
  onClose: () => void;
};

const DialogTerminalNotConnected = ({
  onClose
}: DialogTerminalNotConnectedProps) => {
  return (
    <DialogError childrenPosition="top" onOutsideClick={onClose} size="md">
      <div className="flex flex-col text-center">
        <p className="mb-3 text-2xl">
          <T _str="You need to connect a terminal" />
        </p>

        <p>
          <T
            _str="Go to {deviceSettings} and connect a terminal"
            deviceSettings={
              <NavLink
                className="font-semibold underline hover:text-primary-dark"
                to="/settings/devices"
              >
                <T _str="Device Settings" />
              </NavLink>
            }
          />
        </p>
      </div>
    </DialogError>
  );
};
